function d(v) {
  return parseInt(v, 16);
}

function p(v) {
  return ((d(v) / 255) * 1000) / 1000;
}

export function hexToRGBA(hex: string): string {
  const c = hex.slice(1).match(/.{2}/g) || [];
  const a = p(c[3] || "FF");
  return `rgba(${c.slice(0, 3).map(d).concat(a).join(", ")})`;
}
